const Link = ({ to, label }: { to: string; label: string }) => (
  <a href={to} className="group cursor-pointer">
    <div>{label}</div>
    <div className="h-0.5 w-0 left-0 bg-secondary group-hover:w-full group-hover:right-0 transition-all duration-500"></div>
  </a>
);

export default Link;
